interface HttpError {
  errors?: { status?: number | string }[];
  status?: number | string;
}

// ember-ajax errors expose `status`, ember-data adapter errors list it per error.
export default function isBadRequestError(error: unknown): boolean {
  const { errors, status } = (error ?? {}) as HttpError;

  return [status, errors?.[0]?.status].some((value) => Number(value) === 400);
}
